export default "__VITE_ASSET__CFXtf3c9__"